import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { authService } from '../services';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requiredRole?: 'DEVELOPER' | 'ADMIN' | 'MANAGER' | 'OPERATOR' | 'VIEWER';
  requireAuth?: boolean;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  requiredRole,
  requireAuth = true,
}) => {
  const location = useLocation();

  // Verificar se o usuário está autenticado
  if (requireAuth && !authService.isAuthenticated()) {
    // Redirecionar para login, mas salvar a localização atual para voltar após o login
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Verificar se o usuário tem a role necessária
  if (requiredRole) {
    const userRole = authService.getUserRole();
    
    // Hierarquia de permissões (maior nível pode acessar níveis inferiores)
    const roleHierarchy = {
      DEVELOPER: 5,
      ADMIN: 4,
      MANAGER: 3,
      OPERATOR: 2,
      VIEWER: 1,
    };

    const requiredLevel = roleHierarchy[requiredRole];
    const userLevel = userRole ? roleHierarchy[userRole as keyof typeof roleHierarchy] : 0;

    if (userLevel < requiredLevel) {
      // Se não tiver permissão, redirecionar para dashboard ou página de acesso negado
      return <Navigate to="/dashboard" replace />;
    }
  }

  return <>{children}</>;
};

export default ProtectedRoute;
